export const removeFileExtension = (fileName: string) => {
  const lastDotPosition = fileName.lastIndexOf('.')
  if (lastDotPosition === -1) return fileName
  else return fileName.substr(0, lastDotPosition)
}

export const getFileExtension = (fileName: string) =>
  fileName.substring(fileName.lastIndexOf('.'), fileName.length) || 'N/A'
